import { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import ReactMarkdown from "react-markdown";
import type { DocArticle } from "@itaas/pep-contracts";
import { getDoc } from "../api/pep-api";
import { SiteLayout } from "../components/layout/SiteLayout";
import { SeoHead } from "../components/seo/SeoHead";

export function DocDetailPage() {
  const { id = "" } = useParams();
  const [doc, setDoc] = useState<DocArticle | null>(null);

  useEffect(() => {
    if (id) getDoc(id).then(setDoc).catch(console.error);
  }, [id]);

  if (!doc) {
    return (
      <SiteLayout>
        <div className="container py-5">Chargement…</div>
      </SiteLayout>
    );
  }

  return (
    <SiteLayout>
      <SeoHead
        title={doc.title}
        description={doc.excerpt}
        keywords={doc.seoKeywords}
        canonicalPath={`/docs/${doc.id}`}
      />
      <div className="container py-5">
        <nav aria-label="breadcrumb">
          <ol className="breadcrumb">
            <li className="breadcrumb-item">
              <Link to="/docs">Documentation</Link>
            </li>
            <li className="breadcrumb-item">
              <Link to={`/products/${doc.productSlug}`}>{doc.productName}</Link>
            </li>
            <li className="breadcrumb-item active">{doc.title}</li>
          </ol>
        </nav>
        <article className="pep-doc-content col-lg-9">
          <h1 className="display-6 fw-bold mb-4">{doc.title}</h1>
          <ReactMarkdown>{doc.content}</ReactMarkdown>
        </article>
      </div>
    </SiteLayout>
  );
}
